// extracted by mini-css-extract-plugin
export default {"actionListTitle":"IssueTemplateItem-module__actionListTitle--wBUhO","templateItemContainer":"IssueTemplateItem-module__templateItemContainer--LLWZY"};